/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_In_App_AlertsInputs */

const en_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-app alerts`)
};

const de_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-App-Benachrichtigungen`)
};

const fr_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertes dans l'application`)
};

const es_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas en la aplicación`)
};

const it_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisi nell'app`)
};

const nl_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-app meldingen`)
};

const pl_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia w aplikacji`)
};

const fi_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovellusilmoitukset`)
};

const da_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-app-advarsler`)
};

const sv_jobs_in_app_alerts = /** @type {(inputs: Jobs_In_App_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviseringar i appen`)
};

/**
* | output |
* | --- |
* | "In-app alerts" |
*
* @param {Jobs_In_App_AlertsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_in_app_alerts = /** @type {((inputs?: Jobs_In_App_AlertsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_In_App_AlertsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_in_app_alerts(inputs)
	if (locale === "fr") return fr_jobs_in_app_alerts(inputs)
	if (locale === "es") return es_jobs_in_app_alerts(inputs)
	if (locale === "it") return it_jobs_in_app_alerts(inputs)
	if (locale === "nl") return nl_jobs_in_app_alerts(inputs)
	if (locale === "pl") return pl_jobs_in_app_alerts(inputs)
	if (locale === "fi") return fi_jobs_in_app_alerts(inputs)
	if (locale === "da") return da_jobs_in_app_alerts(inputs)
	if (locale === "sv") return sv_jobs_in_app_alerts(inputs)
	return en_jobs_in_app_alerts(inputs)
});